import {Text} from '../../components/1elements'
import BulkImportFormatTemplate from '../../components/5templates/BulkImportFormatTemplate'
import {englishTexts as words} from '../../consts/Texts'

const Locations = () => {
    const header = 'Add Multiple Locations for a Client from a CSV file'
    const description = (
        <>If you have new locations for a given client, you can add information into a preformatted file to
            import them all at once. Before importing the data, review the <a href={'/format/locations#formatGuidelines'}>format guidelines</a> below to avoid
            <a href={'/format/locations#commonErrors'}>common errors</a> and to ensure a smooth import operation.</>
    )

    const beforeYouBegin = (<>
        <li><Text type={'bulkImportRuleBody'}>
            <b>Validate this is the right way to proceed</b>- Use this option if you have multiple imports.
            You can import up to NEW 1000 locations per client. <b>Note</b> that you can do a single import
            by using the inbuilt smart form under data management.
        </Text></li>
        <li><Text type={'bulkImportRuleBody'}>
            <b>Make sure you have all the information ready</b>- Creating a location requires information related to
            the details and address for the location itself, along with the information about the building where
            the location is located. Since a building acts as a container holding one or more locations and addresses,
            it becomes a primary key for the building-location association. Ensure you have all the information ready
            and refer to the <a href={'/format/locations#columnReference'}>column reference</a> to know about all the mandatory fields.
        </Text></li></>)

    const requiredColumns = [
        {
            columnName: 'Building name',
            description: ['Name of the building which hosts the location. If the location is standalone, enter the building ',
                'name to be the same as the location name. Enter the complete name or commonly referred short name.\n',
                'It is ', <b>recommended</b>, ' to export the existing location to check if your building name already exists in the system.'],
            limit:  'up to 150 characters',
            example: 'Bentall Center 1\n Telus Tower\n Waterfront transit station\n'
        },
        {
            columnName: 'Address Line 1',
            description: 'The street and Avenue address for the location',
            limit:  'up to 200 characters',
            example: '179th street and Abbott avenue'
        },
        {
            columnName: 'City',
            description: 'Enter the complete city name.',
            limit:  'up to 45 characters',
            example: 'Burnaby, Vancouver'
        },
        {
            columnName: 'Province',
            description: 'Enter the complete Province/State name',
            limit:  'up to 45 characters',
            example: 'British Columbia'
        },
        {
            columnName: 'Country',
            description: 'Enter the complete Country name',
            limit:  'up to 45 characters',
            example: 'Canada, United States of America'
        },
        {
            columnName: 'Postal Code',
            description: 'Enter complete postal code/Zip Code characters without any space',
            limit:  'up to 6 characters',
            example: 'V5H1P1, 98007'
        },
        {
            columnName: 'Location Name',
            description: 'Enter the complete name of the location. If this is a standalone location, enter the same name as the building name',
            limit:  'up to 255 characters',
            example: 'Waterfront Transit Station\n ABC Dental Clinic'
        },
        {
            columnName: words.transitId,
            description: 'An alphanumeric business reference code assigned to identify each location uniquely.',
            limit:  'up to 45 characters',
            example: 'AB64N01'
        },
        {
            columnName: 'Job Id',
            description: 'An alphanumeric business reference code assigned to a location based on the type of service offering/ relationship with the client.',
            limit:  'up to 45 characters',
            example: 'AB740, 00070'
        },
        {
            columnName: 'Square Footage',
            description: 'Area in sq. ft.',
            limit:  'up to 25 Characters',
            example: '1232'
        },
    ]

    const optionalColumns = [
        {
            columnName: 'Building Description',
            description: 'Additional information regarding the building',
            format: '',
            limit:  'up to 255 characters',
            example: ''
        },
        {
            columnName: 'Unit',
            description: 'If the location is assigned a unit/floor number in a building, enter the information here',
            format: '',
            limit:  'up to 45 characters',
            example: 'Unit 101 or Floor 4'
        },
        {
            columnName: 'Address Line 2',
            description: 'Enter secondary address information here',
            format: '',
            limit:  'up to 200 characters',
            example: 'Across the coffee shop'
        },
        {
            columnName: 'Location Phone Number',
            description: 'Enter location specific phone number here',
            format: '',
            limit: 'up to 13 characters',
            example: '999-999-9999'
        },
        {
            columnName: 'Location Description',
            description: 'Additional information regarding the Location',
            format: '',
            limit:  'up to 255 characters',
            example: ''
        },
        {
            columnName: words.fmz,
            description: 'If the location falls under a Fisheries Management Zone, enter the information here',
            format: '',
            limit:  'up to 20 characters',
            example: ''
        },
        {
            columnName: 'Security Access',
            description: 'If the building/location requires a code for access, enter the information here',
            format: '',
            limit:  'up to 150 characters',
            example: ''
        },
        {
            columnName: 'Last Inspection Date',
            description: 'Date when a supervisor conducted an inspection at the site/location',
            format: 'YYYY-MM-DD',
            limit:  'up to 150 characters',
            example: '2022-02-01'
        },
        {
            columnName: 'Document Name',
            description: 'If you wish to attach additional document/reports for the location, assign a title for ' +
                'the document here. This title will be visible as a hyperlink on the location tab.',
            format: '',
            limit:  'up to 150 characters',
            example: 'Fire extinguisher report, Quality report, Inventory List'
        },
        {
            columnName: 'Document URL',
            description: ['Uniform Resource Locator/ reference of file storage location.', <br/>, <b>Note</b>,
                ' that the system does not store the source file but only the reference link pointing to the file location.'],
            format: '',
            limit:  '',
            example: 'https://docs.google.com/spreadsheets/d/1xQwIpr'
        },
    ]

    const columnReferencePath = '/format/locations#columnReference'


    return (
        <BulkImportFormatTemplate header={header} description={description} beforeYouBegin={beforeYouBegin}
                                  requiredColumns={requiredColumns} optionalColumns={optionalColumns} columnReferencePath={columnReferencePath} />
    )
}

export default Locations